import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import api from '../../services/api';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import FrSelect from '../FrSelect'
import FrTextInput from '../FrTextInput'


const swal = withReactContent(Swal)

export default function ModalCartao(props) {
    const [data, setData] = useState({});
    const [auth, setAuth] = useState(JSON.parse(localStorage['authsalute'] || JSON.stringify({ authenticated: false, user: 0, residente: 0 })));

    const handleChange = (e) => {
    
        const auxValues = { ...data };
        switch (e.target.name) {
          

          default:
            auxValues[e.target.name] = e.target.value;
        }
        setData(auxValues);
    };
    
    
    function confirmaPagamento(salvaCartao) {
        let auxValues = {
            ...data,
            total: props.total,
            parcelas: props.parcelas,
            salvaCartao: salvaCartao,
            cod_cliente: auth.user
        }

        const options = {
            method: 'POST',
            headers: {accept: 'application/json', 'content-type': 'application/json'},
            body: JSON.stringify({
              card: {
                number: '4000000000000010',
                holder_name: 'teste cliente',
                holder_document: 'CPF',
                exp_month: '1',
                exp_year: 30,
                cvv: '651'
              },
              type: 'card'
            })
        };

        fetch('https://api.pagar.me/core/v5/tokens?appId=pk_8y0eVE3CdsNd7XJE', options)
        .then(res => res.json())
        .then(res => console.log(res))
        .catch(err => console.error(err));
        // api.post('pagarMe/cartao', auxValues).then(res => {
        //     if(res == 'done'){
        //         swal.fire('Sucesso!', 'Agradecemos o seu pagamento!', 'Success').then(r => {
        //             fechaModal()
        //         }) 

        //     } else {
        //         swal.fire('Houve um problema no pagamento', 'Repita a operação!', 'error')
        //     }
        // })
    }



    function verificaErros() {
        if (!data.cartao_titular){
            return swal.fire('Erro', 'Preencha o titular do cartão', 'erro');
        }
        if (!data.cartao_numero){
            return swal.fire('Erro', 'Preencha o número do cartão', 'erro');
        }
        if (!data.cartao_cpf){
            return swal.fire('Erro', 'Preencha o cpf do titular do cartão', 'error');
        }
        if (!data.cartao_validade){
            return swal.fire('Erro', 'Preencha a validade do cartão', 'error');
        }
        if (!data.cartao_cvc){
            return swal.fire('Erro', 'Preencha o cvc do cartão', 'error');
        }
        
        // if (!data.cartao_bandeira){
        //     return swal.fire('Erro', 'Selecione a bandeira do cartão', 'error');
        // }
        if (data.cartao_numero.length !== 19) {
            return swal.fire('Erro', 'Número do cartão inválido', 'error');
        }
        return 'ok'
    }

    function confirmaCartao() {
        // if (verificaErros() === 'ok'){
            
            swal.fire('Confirma pagamento?', '','').then(r => {
                if (r.value) {
                    confirmaPagamento(true)
                }
                    
                
            }) ;
        // }
    }

    function fechaModal() {
        props.closeModal()
    }
    
    return (
        <Dialog aria-labelledby="simple-dialog-title" open={props.showModal} maxWidth={'lg'}>
            
            <div className="modalContent">

                <div style={{flex: 1}}>
                    <div>
                        <FrTextInput
                            id="cartao_titular"
                            name="cartao_titular"
                            label="Nome Titular Cartão"
                            value={data.cartao_titular}
                            variant="outlined"
                            size="small"
                            onChange={handleChange}
                            maxLength='100'
                            style={{width: 446}}
                            required
                        />
                    </div>

                    <div>
                        <FrTextInput
                            id="cartao_numero"
                            name="cartao_numero"
                            label="Número do cartão"
                            keyboardType="numeric"
                            value={data.cartao_numero}
                            variant="outlined"
                            size="small"
                            onChange={handleChange}
                            required
                        />

                        <FrTextInput
                            id="cartao_cpf"
                            name="cartao_cpf"
                            label="CPF Titular"  
                            keyboardType="numeric"
                            value={data.cartao_cpf}
                            variant="outlined"
                            size="small"
                            onChange={handleChange}
                            required

                        />

                    </div>
                    <div>
                        <FrSelect
                            items={[{value: '', display: ''},{value: 'E', display: 'ELO'}, {value: 'H', display: 'HIPERCARD'}, {value: 'M', display: 'MASTERCARD'}, {value: 'V', display: 'VISA'}]}
                            id="cartao_bandeira"
                            name="cartao_bandeira"
                            label="Bandeira"
                            value={data.cartao_bandeira}
                            style={{ width: 190 }}
                            onChange={handleChange}
                            
                        />

                        <FrTextInput
                            id="cartao_validade"
                            name="cartao_validade"
                            keyboardType="numeric"
                            label="Validade (Mês/Ano)"
                            value={data.cartao_validade}
                            variant="outlined"
                            size="small"
                            style={{width: 160}}
                            onChange={handleChange}
                            required
                        />

                        <FrTextInput
                            id="cartao_cvc"
                            name="cartao_cvc"
                            label="CVC"
                            keyboardType="numeric"
                            value={data.cartao_cvc}
                            variant="outlined"
                            size="small"
                            onChange={handleChange}
                            required
                            style={{width: 86}}
                        />
                    </div>
                </div>
            </div>

            <div className="FrModalFooter">
                <div className="FrModalButtonsDiv">
                    <button onClick={confirmaCartao}> Confirmar </button>
                    <button onClick={fechaModal}> Sair </button>
                </div>
            </div>

        </Dialog>
    );
  }